import React from 'react';
import { WorkspaceDisplayProps } from '../types';

export const WorkspaceDisplay: React.FC<WorkspaceDisplayProps> = React.memo(({ projectName, projectIds, projectId, keyId }) => {
  const workspaceNames = projectName
    ? projectName.split(',').map(name => name.trim()).filter(Boolean)
    : [];
  const workspaceIdsList = Array.isArray(projectIds) && projectIds.length > 0
    ? projectIds
    : projectId
      ? [projectId]
      : [];
  const workspaceDisplay = workspaceNames.length > 0
    ? workspaceNames
    : workspaceIdsList.length > 0
      ? workspaceIdsList
      : ['—'];
  const workspaceTitle = workspaceIdsList.length > 0
    ? `Workspace IDs: ${workspaceIdsList.join(', ')}`
    : projectId
      ? `Workspace ID: ${projectId}`
      : undefined;

  if (workspaceDisplay.length === 1 && workspaceDisplay[0] === '—') {
    return <span className="text-gray-400 dark:text-gray-500">—</span>;
  }

  return (
    <div className="flex flex-wrap gap-1 items-center" title={workspaceTitle}>
      {workspaceDisplay.map((name, workspaceIdx) => (
        <span
          key={`${keyId}-workspace-${workspaceIdx}`}
          className="px-2 py-0.5 text-xs rounded-full bg-slate-100 text-slate-700 dark:bg-slate-700 dark:text-slate-200"
        >
          {name}
        </span>
      ))}
    </div>
  );
});
WorkspaceDisplay.displayName = 'WorkspaceDisplay';
